import React, { useEffect, useState } from 'react';
import baseAPI, { PublicApplicationSettingsView } from '../api';

interface ApplicationState {
  appSettings: PublicApplicationSettingsView;
  loading: boolean;
}

const settingsAPI = baseAPI.serverInfo;

const DEFAULT_SETTINGS: PublicApplicationSettingsView = {

  isUsingWisoryVideoPlatform: false,
  isBookingFormWisoryVideoEnabled: false,
  isProfileAppEnabled: false,
  videoPlatforms: [],
  useCognitoOtpLogin: false,
  bookingFormAvailabilityOffset: 24,
  isPingPongWorkflowEnabled: false,
  isWisoryVideoNextEnabled: false,
};

export const ApplicationSettingsContext = React.createContext<ApplicationState>({
  appSettings: DEFAULT_SETTINGS,
  loading: false,
});

const ApplicationSettingsProvider = ({ children }: React.PropsWithChildren<{}>) => {
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [appSettings, setAppSettings] = useState<PublicApplicationSettingsView>(DEFAULT_SETTINGS);

  useEffect(() => {
    function fetchApplicationSettings() {
      setLoading(true);

      settingsAPI
        .getPublicApplicationSettings()
        .then(({ data }) => setAppSettings(data))
        .finally(() => {
          setLoading(false);
          setLoaded(true);
        });
    }

    if (!loaded) {
      fetchApplicationSettings();
    }
  }, [loaded]);

  return (
    <ApplicationSettingsContext.Provider value={{ appSettings, loading }}>
      {children}
    </ApplicationSettingsContext.Provider>
  );
};

export default ApplicationSettingsProvider;
